import React, { useState } from "react";
import Header from "../components/Header";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { CheckCircle2, LifeBuoy } from "lucide-react";
import { toast } from "sonner";

export default function Support() {
  const [form, setForm] = useState({ nome: "", cognome: "", telefono: "", email: "", messaggio: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    for (const k of Object.keys(form)) {
      if (!form[k].trim()) {
        toast.error("Tutti i campi sono obbligatori");
        return;
      }
    }
    setSubmitting(true);
    try {
      const r = await api.post("/tickets", form);
      setDone(true);
      toast.success(r.data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore invio ticket");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-14">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center bg-cyan-500/10 border border-cyan-500/30 text-cyan-300">
            <LifeBuoy className="w-7 h-7" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-white/40">Assistenza</div>
            <h1 className="text-3xl md:text-4xl font-black tracking-tight">Apri un Ticket</h1>
          </div>
        </div>

        {done ? (
          <div
            data-testid="ticket-success"
            className="bg-[#0E0E11] border border-white/10 rounded-2xl p-10 text-center"
            style={{ borderTop: "4px solid #10B981" }}
          >
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-400 mb-4" />
            <h2 className="text-2xl font-bold mb-2">Ticket Aperto</h2>
            <p className="text-white/70">
              Verrai contattato nel più breve tempo possibile, Grazie!
            </p>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="bg-[#0E0E11] border border-white/10 rounded-2xl p-6 md:p-8 space-y-5"
            style={{ borderTop: "4px solid #00E5FF" }}
          >
            <div className="grid md:grid-cols-2 gap-5">
              <div>
                <Label className="text-xs uppercase tracking-wider text-white/60">Nome *</Label>
                <Input
                  data-testid="ticket-nome"
                  value={form.nome}
                  onChange={(e) => setField("nome", e.target.value)}
                  className="mt-1.5 bg-black/60 border-white/10 text-white"
                />
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-white/60">Cognome *</Label>
                <Input
                  data-testid="ticket-cognome"
                  value={form.cognome}
                  onChange={(e) => setField("cognome", e.target.value)}
                  className="mt-1.5 bg-black/60 border-white/10 text-white"
                />
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-white/60">Telefono *</Label>
                <Input
                  data-testid="ticket-telefono"
                  value={form.telefono}
                  onChange={(e) => setField("telefono", e.target.value)}
                  className="mt-1.5 bg-black/60 border-white/10 text-white"
                />
              </div>
              <div>
                <Label className="text-xs uppercase tracking-wider text-white/60">Email *</Label>
                <Input
                  data-testid="ticket-email"
                  type="email"
                  value={form.email}
                  onChange={(e) => setField("email", e.target.value)}
                  className="mt-1.5 bg-black/60 border-white/10 text-white"
                />
              </div>
            </div>

            <div>
              <Label className="text-xs uppercase tracking-wider text-white/60">Messaggio *</Label>
              <Textarea
                data-testid="ticket-messaggio"
                value={form.messaggio}
                onChange={(e) => setField("messaggio", e.target.value)}
                rows={6}
                className="mt-1.5 bg-black/60 border-white/10 text-white"
              />
            </div>

            <Button
              type="submit"
              data-testid="ticket-submit-btn"
              disabled={submitting}
              className="w-full h-14 rounded-full font-bold tracking-widest text-white border-0 bg-gradient-to-r from-[#FF5722] to-[#00E5FF] hover:-translate-y-0.5 transition-transform shadow-[0_0_30px_rgba(0,229,255,0.4)]"
            >
              {submitting ? "INVIO..." : "APRI TICKET"}
            </Button>
          </form>
        )}
      </main>
    </div>
  );
}
